import { ReactElement } from 'react';
import styles from './ClientCreationForm.module.scss';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import {
  ClientCreationFormSchema,
  TClientCreationForm,
} from '../model/ClientCreationFormSchema';
import { zodResolver } from '@hookform/resolvers/zod';
import { BackButton, Button, Typography } from '../../../1_shared/ui';
import { phoneConvert } from '../../../1_shared/lib/helpers/phoneConvert';
import { ClientCreationByAdmin } from '../../../1_shared/api/services';
import { ERoles } from '../../../1_shared/config/enums/ERoles';
import useMessage from 'antd/es/message/useMessage';
import { RoutePath } from '../../../1_shared/config/routes';
import FormFields from './components/FormFields';

const ClientCreationForm = (): ReactElement => {
  const [messageApi, contextHolder] = useMessage();

  /* Services */
  const { createClient, creatingClient } = ClientCreationByAdmin();
  /* Services */

  const methods = useForm<TClientCreationForm>({
    defaultValues: { phone: '', nickname: '', email: '' },
    mode: 'onSubmit',
    resolver: zodResolver(ClientCreationFormSchema),
  });

  const { handleSubmit, reset } = methods;

  const onSubmit = async (data: FieldValues) => {
    await createClient({
      nickname: data.nickname,
      phone: phoneConvert(data.phone),
      email: data.email ? data.email : null,
      roles: ERoles.Client,
    })
      .then(() => {
        messageApi.open({
          type: 'success',
          content: 'Пользователь успешно создан',
          duration: 15,
        });
        reset();
      })
      .catch(error => {
        messageApi.open({
          type: 'warning',
          content: error.response.data,
          duration: 15,
        });
      });
  };

  return (
    <section className={styles.root}>
      {contextHolder}
      <BackButton pathTo={RoutePath.ADMIN_CABINET} />
      <section className={styles.title}>
        <Typography type="title" component="h1">
          Создание клиента
        </Typography>
      </section>

      <FormProvider {...methods}>
        <form className={styles.container} onSubmit={handleSubmit(onSubmit)}>
          <FormFields />
          <Button
            htmlType="submit"
            disabled={creatingClient}
            loading={creatingClient}
          >
            Добавить нового клиента
          </Button>
        </form>
      </FormProvider>
    </section>
  );
};

export default ClientCreationForm;
